import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";

export const voice_case3 = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様インタビュー｜職場近くのウォークインクローゼット'; 
  return (
    <div className="container">
      {breadcrumbs(type, [
        { href: "/voice2/", text: "お客様の声" },
        {
          text: " 職場近くのウォークインクローゼット",
        },
      ])}
      
      <div className="voice_case">
        <h2>活用事例</h2>
        <div className="content">
          <div className="collection">
            <div className="interview_header">
              <div className="title">お客様のご紹介</div>
              <div className="person">
                <span>五十嵐様</span>
                <br />
                <span>広告代理店勤務　34歳</span>
              </div>
              <div className="profile">
                <span>
                  人前に出る機会が多いため、ファッションにはこだわりあり。
                  <br />
                </span>
                <span>手取りの半分が服代に消えることもあるとか･･･</span>
              </div>
            </div>
            <Link to="/tokyo/chiyodaku/detail/1427/" className="item attention">
              <div className="type star">物件データ</div>
              <div className="title">
                  ハローストレージ麹町（四ツ谷・永田町）
              </div>
              <div className="price">
                17,700 /月〜 75,600 /円/月 (1帖〜5.4帖)
              </div>
              <div className="address">東京都千代田区麹町3丁目5-1</div>
              <div className="transportation">
                東京メトロ有楽町線　麹町 駅　徒歩 4 分
              </div>
              <div className="image premium" />
            </Link>
          </div>
          <div className="h_border" />
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case3/img_1.jpg" />
            <div className="title">職場近くのウォークインクローゼット</div>
            <div className="question">Ｑ：借りようと思ったきっかけは？</div>
            <div className="answer">
              <span>
                業界的に時間が不規則で、コンペ前には自宅に帰れない日もあります。クライアントに会う日はスーツも上質なものを身につけたいのですが、身なりを整えるためだけに自宅に戻るのは、時間とタクシー代がもったいない。
              </span>
              <br />
              <span>
                かといって、職場に私物を置くスペースもないので、机の周りは服や荷物で溢れ返っていました。
              </span>
              <br />
              <span>
                ある日、とうとうシニアディレクターに喫煙所で注意されてしまいました。「いい加減にしないと、荷物、実家に送るぞ。」と。いつもは温和な上司の目が、そのときだけは怖かった･･･。
              </span>
              <br />
              <span>で、どうにかしようと決心したんです。</span>
            </div>
          </div>
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case3/img_2.jpg" />
            <div className="title">使ってみたら意外と便利！</div>
            <div className="question">Ｑ：どうやって選びましたか？</div>
            <div className="answer">
              <span>
                以前、引越しのときにコンテナを1ヶ月半くらい使ったことがあったので、今回は割りと小さめのサイズでロッカー代わりに借りられるところを探しました。
                <br />
              </span>
              <span>
                選ぶとき重要視したのは
                <br />
              </span>
              <span>
                1　職場から近いこと
                <br />
              </span>
              <span>
                2　ネットから手続きができること
                <br />
              </span>
              <span>
                3　24時間利用できること
                <br />
              </span>
              <span>
                その3つを満たすのがハローストレージでした。
                <br />
              </span>
              <span>
                Ｑ：どの様に活用していますか？また、工夫していることはありますか？
                <br />
              </span>
              <span>
                コンペ前など忙しい時期は、仕事（職場～仮眠）⇒ジム（シャワー、たまに運動）⇒トランクルーム⇒仕事というサイクルで使用しています。
              </span>
              <br />
              <span>あと、結構便利だと感じるのが、クリーニングの活用。</span>
              <br />
              <span>
                クリーニングも職場近くで出して、そのままシーズンオフのものを収納してます。衣替えの手間もなくて済むし、急な呼び出しも勝負服で臨めるからいいですよ。ワイシャツも常に10枚くらいはストックしています。
              </span>
              <br />
              <span>
                鏡やハンガーラック、カラーボックスを持ち込んで、着実にウォークインクローゼット化が進んでいます。
              </span>
              <br />
              <span>それこそ誰かに自慢したいくらい（笑）</span>
              <br />
              <span>
                今から解約時の荷物の運び出しが不安になるほど、活用しています。
              </span>
              <span />
            </div>
          </div>
          <div className="interview_footer">
            <div className="message">
              <span>五十嵐様、</span>
              <span>ご協力ありがとうございました。</span>
              <span>※本文章は弊社社員のお客様インタビューを</span>
              <span>再構成し、掲載しております。</span>
            </div>
          </div>
          <Link to="/voice2/voice_case4/" className="btn black">
            その他の活用事例を見る
          </Link>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/voice_case3.jsx